import axiosInstance from 'services/axios/axios';
import { getSession } from 'store/utility';

export const doesUserHaveBotSponsor = async esoid => {
	try {
		const trackingNumber = await getSession('newTrackingNum');
		const hasTrackingNumber =
			trackingNumber !== undefined &&
			trackingNumber !== null &&
			String(trackingNumber).trim() !== '';

		const endpoint = hasTrackingNumber
			? `api/ESO/NonEmployee/RequesteeHasBotSponsor/${esoid}?trackingNumber=${encodeURIComponent(String(trackingNumber).trim())}`
			: `api/ESO/NonEmployee/RequesteeHasBotSponsor/${esoid}`;

		const response = await axiosInstance.get(endpoint);

		if (response.data?.payload) {
			return response.data.payload;
		}

		return;
	} catch (ex) {
		throw ex;
	}
};
